/**
 * Shared SVG hatch pattern definitions for bars and legends.
 * Keeping this in one place ensures legend swatches and bars render identical motifs.
 */

export const HATCH_TILE_SIZE = 8;

function HatchPatternMarks({ variant = 0 }) {
  const normalized = ((variant % 4) + 4) % 4;
  if (normalized === 0) {
    return <path d="M0,8 L8,0 M-2,2 L2,-2 M6,10 L10,6" stroke="#00000055" strokeWidth="1" />;
  }
  if (normalized === 1) {
    return (
      <>
        <path d="M0,0 L0,8 M4,0 L4,8 M8,0 L8,8" stroke="#00000044" strokeWidth="1" />
        <path d="M0,0 L8,0 M0,4 L8,4 M0,8 L8,8" stroke="#00000033" strokeWidth="1" />
      </>
    );
  }
  if (normalized === 2) {
    return <path d="M2,0 L2,8 M6,0 L6,8" stroke="#00000055" strokeWidth="1" />;
  }
  return (
    <>
      <circle cx="2" cy="2" r="1" fill="#00000055" />
      <circle cx="6" cy="6" r="1" fill="#00000055" />
    </>
  );
}

export function HatchPatternDefs({ idPrefix, colors = [], variantIndices = [] }) {
  return (
    <defs>
      {colors.map((color, idx) => {
        const variant = variantIndices[idx] ?? idx;
        return (
          <pattern
            key={`${idPrefix}-${idx}`}
            id={`${idPrefix}-${idx}`}
            patternUnits="userSpaceOnUse"
            width={HATCH_TILE_SIZE}
            height={HATCH_TILE_SIZE}
          >
            <rect width={HATCH_TILE_SIZE} height={HATCH_TILE_SIZE} fill={color} />
            <HatchPatternMarks variant={variant} />
          </pattern>
        );
      })}
    </defs>
  );
}
